'use client'

import React, { useState } from 'react'
import classNames from 'classnames'
import LogInIcon from '@dustin-web/microsite-components/src/icon/generated/log-in'
import { useComponentVisible } from '@dustin-web/microsite-components/src/hooks'
import Drawer from '@dustin-web/microsite-components/src/drawer'
import dynamic from 'next/dynamic'
import '@dustin-web/microsite-components/src/okta-login-widget/okta-login-widget.scss'

// Dynamically import your widget container component with SSR disabled
const OktaLoginWidget = dynamic(
  () => import('@dustin-web/microsite-components/src/okta-login-widget/okta-login-widget'),
  {
    ssr: false,
  }
)

export const OktaAccountMenuLoginDrawer = () => {
  const { componentRef, isVisible } = useComponentVisible<HTMLLIElement>(false)
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)

  const loginHandler = async () => {
    setIsDrawerOpen(true)
  }

  const closeDrawer = () => {
    setIsDrawerOpen(false)
  }

  return (
    <>
      <li
        className={classNames('c-header__user-item c-header__dropdown', {
          'c-header__dropdown--active': isVisible,
        })}
        ref={componentRef}>
        <button
          id="dustin-registration-header-link"
          className="c-header__user-btn c-header__dropdown-btn button-stripped"
          onClick={e => {
            e.preventDefault() // Prevent navigation
            loginHandler()
          }}>
          <span className="c-header__user-icon">
            <LogInIcon name="log-in" />
          </span>
          <div className="u-relative d-flex flex-column no-mouseflow-dom">Testing okta</div>
        </button>
      </li>

      {/* Drawer Component */}
      {isDrawerOpen && (
        <Drawer
          usePortal={true}
          visible
          onClose={closeDrawer}
          customBreakpointWidth={{ xl: '50vw' }}
          maxWidth="60rem"
          className="c-minicart u-px-0 u-pt-16 u-pt-lg-24 u-pb-0 u-color-black d-flex flex-column">
          <div className="u-relative d-flex flex-column" style={{ minHeight: '100%' }}>
            <div className="d-flex align-items-center u-px-24 u-mb-16 u-mb-lg-24">
              <OktaLoginWidget />
            </div>
          </div>
        </Drawer>
      )}
    </>
  )
}

export default OktaAccountMenuLoginDrawer
